import type { AdventureContent } from "../types/adventure";
import { CockpitLights } from "./CockpitLights";

interface CockpitFrameProps {
  adventure: AdventureContent;
  images: Record<string, string | null>;
  roundNumber: number;
  phase: string;
}

export function CockpitFrame({
  adventure,
  images,
  roundNumber,
  phase,
}: CockpitFrameProps) {
  const bgUrl = images.background;
  const cockpitUrl = images.cockpit;
  const roundKey = `round-${roundNumber}`;
  const sceneUrl = images[roundKey] ?? images.goal;

  return (
    <div className="act-cockpit" data-adventure={adventure.id}>
      <div
        className="act-cockpit__background"
        style={bgUrl ? { backgroundImage: `url(${bgUrl})` } : undefined}
        aria-hidden
      />
      <div
        className="act-cockpit__scene"
        style={sceneUrl ? { backgroundImage: `url(${sceneUrl})` } : undefined}
        data-phase={phase}
        aria-hidden
      >
        {!sceneUrl && (
          <div className="act-cockpit__scene-placeholder">
            <span className="act-cockpit__goal-icon">{adventure.goal.icon}</span>
            <span>{adventure.goal.name}</span>
          </div>
        )}
      </div>
      <div
        className="act-cockpit__frame"
        style={cockpitUrl ? { backgroundImage: `url(${cockpitUrl})` } : undefined}
        aria-hidden
      />
      <CockpitLights adventureId={adventure.id} />
      <div className="act-cockpit__hud">
        <span className="act-cockpit__goal">
          {adventure.goal.icon} {adventure.goal.name}
        </span>
        <span className="act-cockpit__rounds" aria-label={`Ronde ${roundNumber} van 5`}>
          {[1, 2, 3, 4, 5].map((n) => (
            <span
              key={n}
              className={
                n === roundNumber
                  ? "act-cockpit__pip act-cockpit__pip--active"
                  : n < roundNumber
                    ? "act-cockpit__pip act-cockpit__pip--done"
                    : "act-cockpit__pip"
              }
            />
          ))}
        </span>
      </div>
    </div>
  );
}
